/**
 * Created by nkarnik on 8/1/2016.
 */
import 'babel-polyfill';
import PapaParse from 'papaparse';

const Model = {
    categories: {
        names: [],
        values: []
    },
    attributes: {
        names: [],
        values: []
    },
    primary: {
        names: [],
        values: []
    },
    xAxis: {
        name: "",
        values: []
    },
    yAxis: {
        names: [],
        values: [],
    }
};

const modelString = JSON.stringify(Model);

export default class SpaghettiData {

    constructor(csvObj) {
        this.parsedJSON = this.convertToJSON(csvObj);
        this.rawdata = this.parsedJSON.data;
        this.data = JSON.parse(modelString);

        this.processCSV();
    }

    convertToJSON(csv) {
        // Config => http://papaparse.com/docs#config
        return PapaParse.parse(csv, {
            worker: false,
            skipEmptyLines: true,
            dynamicTyping: true,
            fastMode: true
        });
    }

    processCSV() {

        for (let row of this.rawdata) {
            if (row.length <= 0)
                continue;

            const firstItem = row[0];

            if (typeof firstItem == "string") {
                if (firstItem.startsWith("cat")) {
                    this.addCategoryRow(row);
                }
                else if (firstItem.startsWith("att")) {
                    this.addAttributeRow(row);
                }
                else if (firstItem.startsWith("primary")) {
                    this.addPrimaryRow(row);
                }
                else if (firstItem.startsWith("x.")) {
                    this.addHeaderRow(row);
                }
                else {
                    this.addValueRow(row);
                }
            }
            else // treat as value for now
            {
                this.addValueRow(row);
            }

        }

        // Cleanup the yAxis (remove trailing nulls)
        for (let i=0; i<this.data.yAxis.values.length; i++){
            const series_values = this.data.yAxis.values[i]
            // iterate backward to remove all the nulls
            let j = series_values.length
            while (j-- && !series_values[j]){
                series_values.splice(j,1)
            }
        }

    }

    cleanupName(name){
        //Remove cat. or att. or x. or y.
        name = name.replace(/^(.+\.)(.*)/, "$2")
        // Replace - by spaces
        name = name.replace(/-/g, ' ')
        // Capitalize every words
        name = name.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1)})

        return name
    }

    addCategoryRow(cat) {
        this.data.categories.names.push(this.cleanupName(cat[0]));
        this.data.categories.values.push(cat.slice(1));
    }

    addAttributeRow(att) {
        this.data.attributes.names.push(this.cleanupName(att[0]));
        this.data.attributes.values.push(att.slice(1));
    }

    addPrimaryRow(primary) {
        this.data.primary.names.push(this.cleanupName(primary[0]));
        this.data.primary.values.push(primary.slice(1));
    }

    addHeaderRow(header) {
        this.data.xAxis.name = this.cleanupName(header[0]);

        var yHeader = header.slice(1);
        let self = this;
        yHeader = yHeader.map(function(val, index, arr) {
            return self.cleanupName(val)
        });

        this.data.yAxis.names = yHeader;
    }

    addValueRow(values) {
        var self = this;
        this.data.xAxis.values.push(values[0]);

        var yData = values.slice(1);
        if(this.data.yAxis.values.length == 0)
        {
            for(var i=0; i<yData.length; i++)
            {
                this.data.yAxis.values.push([]);
            }
        }

        yData.forEach(function(val, index, arr) {
            self.data.yAxis.values[index].push(val == "NaN" ? null : val);
        });
    }

    getXAxis() {
        return this.data.xAxis;
    }

    getYAxisNames(){
        return this.data.yAxis.names;
    }

    getYAxisValues(index) {
        let val = this.data.yAxis.values.map(function (currentValue, currentIndex, array) {
            return currentValue[index];
        });
        return val;
    }

    getCategories() {
        return this.data.categories;
    }

    getAttributes() {
        return this.data.attributes;
    }

    getPrimary() {
        return this.data.primary;
    }

    getFilters() {

        var results = [];
        for(var index=0; index<this.data.categories.names.length; index++) {
            results.push([].concat(this.data.categories.names[index], this.data.categories.values[index]));
        }

        for(var index=0; index<this.data.attributes.names.length; index++) {
            results.push([].concat(this.data.attributes.names[index], this.data.attributes.values[index]));
        }

        for(var index=0; index<this.data.primary.names.length; index++) {
            results.push([].concat(this.data.primary.names[index], this.data.primary.values[index]));
        }

        return results;
    }

    getData() {
        return this.data;
    }

    print() {
        console.log(this.data);
        console.log(this.getYAxisValues(1));
    }
}


/** WEBPACK FOOTER **
 ** ./src/SpaghettiData.js
 **/